import { data } from 'jquery'
import React from 'react'
import Toggle from 'react-toggle'

const CompanyDataThreshold = (props) => {
	const { data, errMessage, setPropStates } = props
	const { data_threshold_pct_global, data_threshold_pct, data_threshold_type } = data

	const onChange = (event) => {
		const { target } = event
		const { name } = target
		let value = target.type === 'checkbox' ? target.checked : target.value

		if (name === 'data_threshold_type') {
			value = value ? 'company' : 'global'
		}

		setPropStates({ data: { ...data, [name]: value } })
	}

	const onInputChange = (e) => {
		const re = /^[0-9\b]+$/
		if (e.target.value === '' || re.test(e.target.value)) {
			setPropStates({ data: { ...data, data_threshold_pct: e.target.value } })
		}
	}

	return (
		<div style={{ border: '1px solid', padding: '10px' }}>
			<h4 style={{ marginTop: 0, fontSize: '18px' }}>Company Vehicle Data Threshold Settings</h4>
			<div className="category-subheader">
				A maximum data cap threshold for total data usage per device within the company. Company value overrides global value if selected.
			</div>
			<div className="two-column-grid with-margin margin-top" style={{ marginBottom: '20px' }}>
				<div className={errMessage.data_threshold_pct && 'has-error'}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<label style={{ marginRight: '20px', width: '185px', textAlign: 'right' }}>Global Threshold Value</label>
						<span style={{ width: '70px', padding: '5px 18px 9px 18px', fontSize: '16px' }}>{data_threshold_pct_global}</span>
						<span style={{ marginLeft: '20px' }}>%</span>
					</div>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<label style={{ margin: '5px 20px 0px 0px', width: '185px', textAlign: 'right' }}>Company Threshold Value</label>
						<input
							type="number"
							step="1"
							min="100"
							maxLength="4"
							value={(data_threshold_pct * 1).toFixed(0)}
							className="vehicle-search number-input mr-10 pt-5"
							name="data_threshold_pct"
							onChange={onInputChange}
							readOnly={data_threshold_type !== 'company'}
						/>
						{/* <input
							type="text"
							maxLength="3"
							className="vehicle-search"
							value={companyThreshold}
							name="companyThreshold"
							style={{ width: '70px', padding: '5px 20px 0 20px', marginRight: '10px' }}
							readOnly={companyThresholdType !== 'company'}
							onChange={onInputChange}
						/> */}
						<span>%</span>
					</div>
					{errMessage.data_threshold_pct && <span className="help-block" style={{ marginLeft: '90px' }}>{errMessage.data_threshold_pct}</span>}
				</div>
				<div className="toggles-container">
					<div className="toggle-wrapper">
						<div>
							<label htmlFor="advanced_profile_settings" className="control-label" style={{ paddingLeft: '45px', fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>
								Use Threshold Type:
							</label>
						</div>
						<label>
							<span className="toggle-left-title">Global Value</span>
							<Toggle
								name="data_threshold_type"
								checked={data_threshold_type === 'company'}
								onChange={onChange}
							/>
							<span>Company Value</span>
						</label>
					</div>
				</div>
			</div>
		</div>
	)
}

export default CompanyDataThreshold;
